import { FC } from 'react'
import { Alert } from 'hello-design-system'
import { styled } from '@mui/material'

// Below the network snackbars so connection warnings always stay on top
export const CLASS_END_WARNING_Z_INDEX = 1400

type ClassEndWarningProps = {
    open: boolean
    message: string
    onClose?: () => void
}

const WarningAnchor = styled('div')(({ theme }) => ({
    position: 'fixed',
    zIndex: CLASS_END_WARNING_Z_INDEX,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    top: theme.spacing(1),
    left: theme.spacing(1),
    right: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
        top: theme.spacing(3),
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    },
    '.MuiAlert-root': {
        width: 'auto',
        marginBottom: 0,
        pointerEvents: 'auto'
    }
}))

const ClassEndWarning: FC<ClassEndWarningProps> = ({ open, message, onClose }) => {
    if (!open) {
        return null
    }

    return (
        <WarningAnchor data-testid='class-end-warning'>
            <Alert
                severity='info'
                variant='outlined'
                description={message}
                onClose={onClose}
            />
        </WarningAnchor>
    )
}

export { ClassEndWarning }
